import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PreloaderAdmin = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Check if the current path is any /admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdminRoute) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000); // delay time
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  if (!isAdminRoute || !loading) return null;

  return (
    <div
      id="preloader"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100%',
        backgroundColor: 'transparent',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <img
        src="/assets/images/newpreloader.svg"
        height="100px"
        alt="Loading..."
      />
    </div>
  );
};

export default PreloaderAdmin;
